module.exports = __webpack_public_path__ + "img/solution@2x.5e1916f0.png";